import { LayoutActions } from '@gestor-web/@core/store/actions';
import { createReducer, on } from '@ngrx/store';

// const menu = SIDEBAR_MENU;

export const featureKey = 'layout';

export interface State {
  topbarTheme: string;
  menuTheme: string;
  layoutMode: string;
  menuMode: 'static' | 'overlay' | 'horizontal' | 'slim';
  inputStyle: string;
  ripple: boolean;
  /* @ deprecated Nâo estão mais sendo usados menu e breadcrums no state global.
  menu: MenuItem[];
  breadcrumb: {
    items: MenuItem[];
    home: MenuItem;
  };
  */
  title: string;
  fullscreen: boolean;
}

export const initialState: State = {
  topbarTheme: 'blendus',
  menuTheme: 'blendus',
  layoutMode: 'light',
  menuMode: 'static',
  inputStyle: 'outlined',
  ripple: true,
  /*
  menu,
  breadcrumb: {
    items: [],
    home: { icon: 'pi pi-home', routerLink: '/' },
  },
  */
  title: '',
  fullscreen: false,
};

export const reducer = createReducer(
  initialState,

  /* @deprecated não esta mais sendo usado breadcrumb no state global. Comentado para evitar processamento desnecessário.
  on(LayoutActions.updateBreadcrumb, (state, { items }) => {
    const { breadcrumb } = state;
    return { ...state, breadcrumb: { ...breadcrumb, items } };
  }),
  */

  on(LayoutActions.changePageTitle, (state, { title }) => {
    return { ...state, title };
  }),

  on(LayoutActions.toggleFullscreen, (state, { toggle }) => {
    return {
      ...state,
      fullscreen: toggle ?? !state.fullscreen,
    };
  }),
);
